<mat-form-field class="flex-1" subscriptSizing="dynamic">
  <mat-label>Select Organisation</mat-label>
  <mat-select
    [formControl]="organisationCtrl"
    panelWidth
    [compareWith]="compareFn"
  >
    @if (filteredOrganisations$ | async; as organisations) {
      <mat-option>
        <ngx-mat-select-search
          noEntriesFoundLabel="No organisations found"
          placeholderLabel="Search Organisations..."
          [formControl]="searchCtrl"
        ></ngx-mat-select-search>
      </mat-option>

      @for (organisation of organisations; track organisation.ref.path) {
        <mat-option [value]="organisation">
          <div class="flex items-center gap-4">
            <span>{{ organisation.name }}</span>
            <pr-organisation-status dense [status]="organisation.status" />
          </div>
        </mat-option>
      }
    }
  </mat-select>
</mat-form-field>
